export default "__VITE_ASSET__93640853__"